import React from 'react';
import {
  getReferralStatusConfig,
  getLedgerTypeConfig,
} from './referralStatusUtils';

// kind="status" -> referral reward status; kind="ledger" -> credit ledger type.
// `fallbackLabel`: bilinmeyen kodda API'nin statusname/typename değeri.
const ReferralStatusBadge = ({ kind = 'status', code, fallbackLabel }) => {
  const config =
    kind === 'ledger'
      ? getLedgerTypeConfig(code, fallbackLabel)
      : getReferralStatusConfig(code, fallbackLabel);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default ReferralStatusBadge;
